import { render, staticRenderFns } from "./SupportMoved.vue?vue&type=template&id=2ab149e5&scoped=true"
import script from "./SupportMoved.vue?vue&type=script&lang=js"
export * from "./SupportMoved.vue?vue&type=script&lang=js"
import style0 from "./SupportMoved.vue?vue&type=style&index=0&id=2ab149e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab149e5",
  null
  
)

export default component.exports